import React, { Component } from 'react'
import update from 'immutability-helper'
import PropTypes from 'prop-types'
import { Columns, Column } from '../Layout'

export class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      invalidFields: [],
    }
  }

  componentDidUpdate() {
    this.isValid()
  }

  isInputValid(input) {
    const itemPosition = this.state.invalidFields.indexOf(input.key)
    const fields = this.state.invalidFields

    if (!input.valid) {
      if (itemPosition === -1) {
        fields.push(input.key)
        this.setState(
          update(this.state, {
            invalidFields: {
              $set: fields,
            },
          }),
        )
      }
    } else if (itemPosition > -1) {
      fields.splice(itemPosition, 1)
      this.setState(
        update(this.state, {
          invalidFields: {
            $set: fields,
          },
        }),
      )
    }
  }

  isValid() {
    if (!this.props.isValid) {
      return
    }
    if (this.state.invalidFields.length <= 0) {
      this.props.isValid(true)
    } else {
      this.props.isValid(false)
    }
  }

  childrenWithProps() {
    return React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        isValid: input => this.isInputValid(input),
      })
    })
  }

  render() {
    return (
      <form id={this.props.formId}>
        <Columns>
          <Column col12>{this.childrenWithProps()}</Column>
        </Columns>
      </form>
    )
  }
}

Form.defaultProps = {
  children: null,
  isValid: null,
}

Form.propTypes = {
  formId: PropTypes.string.isRequired,
  children: PropTypes.any,
  isValid: PropTypes.func,
}
